import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const AlertModal = ({ isOpen, onClose, message, type}) => {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            style={customStyles}>
            <div>
                <div style={{ minWidth: '300px' }} className="flex-h flex-center">
                    <h1 className="f-200" dangerouslySetInnerHTML={{ __html: message }} ></h1>
                </div>
                {type===1 && <button onClick={() => onClose()} className="mt-24 button is-success is-fullwidth center">Close</button>}
                {type===2 && <button onClick={() => onClose()} className="mt-24 button is-warning is-fullwidth center">Close</button>}
                {type===3 && <button onClick={() => onClose()} className="mt-24 button is-danger is-fullwidth center">Close</button>}
            </div>
        </Modal>
    );
}

export default AlertModal;